/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { HaveTheApp } from '../HaveTheApp/HaveTheApp';
import { MeetOnTheWeb } from '../MeetOnTheWeb/MeetOnTheWeb';
import { Flex } from '@getgo/chameleon-chakra-ui';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  ariaLabel: {
    id: 'firstJoinNative.ariaSelfHelp',
  },
});
interface Props {
  meetingLinkWeb?: string;
}

export const JoinSelfHelpBoxes: React.FC<Props> = (props) => {
  const { formatMessage: f } = useIntl();
  const { meetingLinkWeb } = props;
  return (
    <Flex
      id='selfHelpBox'
      direction='column'
      alignSelf='flex-end'
      color='#ced8e3'
      maxW='22rem'
      mt={4}
      pr={4}
      aria-label={f(messages.ariaLabel)}
    >
      <HaveTheApp />
      {meetingLinkWeb && <MeetOnTheWeb meetingLink={meetingLinkWeb} />}
    </Flex>
  );
};
